import { C as T } from "./component-B88NZlIm.js";
import { d as b } from "./utilities-D-QcnR4L.js";
class C extends T {
  connectedCallback() {
    (super.connectedCallback(), this.#t());
  }
  #t() {
    (this.#e(), this.querySelectorAll("table").forEach(this.#n.bind(this)));
  }
  #e() {
    const n = document.createTreeWalker(this, NodeFilter.SHOW_TEXT),
      r = [];
    for (; n.nextNode(); ) r.push(n.currentNode);
    for (const o of r) {
      if (!o.textContent.includes("[TABLE]")) continue;
      let t = o.parentElement;
      for (; t && !t.textContent.includes("[/TABLE]"); ) t = t.parentElement;
      if (!t) continue;
      const l = t.innerHTML,
        d = /\[TABLE\]([\s\S]*?)\[\/TABLE\]/g,
        i = l.replace(d, (L, m) => {
          const p = m.replace(
              /<br\s*\/?>/gi,
              `
`
            ),
            c = document.createElement("div");
          c.innerHTML = p;
          const s = (c.textContent || "")
            .split(
              `
`
            )
            .map((e) => e.trim())
            .filter((e) => e.length > 0);
          if (s.length === 0) return "";
          const h = `<thead><tr>${s[0]
              .split("|")
              .map((e) => `<th>${e.trim()}</th>`)
              .join("")}</tr></thead>`,
            a = s
              .slice(1)
              .map(
                (e) =>
                  `<tr>${e
                    .split("|")
                    .map((u) => `<td>${u.trim()}</td>`)
                    .join("")}</tr>`
              )
              .join(""),
            f = a ? `<tbody>${a}</tbody>` : "";
          return `<table>${h}${f}</table>`;
        });
      i !== l && (t.innerHTML = i);
    }
  }
  #n(n) {
    const r = document.createElement("div");
    r.classList.add("rte-table-wrapper");
    const o = n.parentNode;
    o && (o.insertBefore(r, n), r.appendChild(n));
  }
}
b("rte-formatter", C);
